import { render, staticRenderFns } from "./ProductSetSelection.vue?vue&type=template&id=71280f10&scoped=true"
import script from "./ProductSetSelection.vue?vue&type=script&lang=js"
export * from "./ProductSetSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71280f10",
  null
  
)

export default component.exports